
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div className='title'>Hinweise an die Redaktion</div>
    <p>{`Hinweise an die Redaktion
Leben Sie in einem Gefahrengebiet? Wissen Sie von stark gefährdeten sensiblen Objekten? Ihren Hinweis nimmt das Recherche-Desk von Tamedia gerne entgegen unter `}<a href="mailto:recherchedesk@tamedia.ch">{`recherchedesk@tamedia.ch`}</a>{`.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;